// Redux Resources
import { createResourceActions } from "src/redux_resources_v1";

export const framesResourceActions = createResourceActions("frames");
